import { render, staticRenderFns } from "./invoiceItemBreakdown.vue?vue&type=template&id=7b6de7ff"
import script from "./invoiceItemBreakdown.vue?vue&type=script&lang=js"
export * from "./invoiceItemBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports